export default __webpack_public_path__ + "static/swipe-hint-0c7d42f3bc7f1a3e0f452a4248744902.gif";